export const environment = {
  production: true,
  program: 'web',
  baseUrl: 'https://admin.staging.curbnturf.com',
  apiUrl: 'https://api.staging.curbnturf.com',
  poiApiUrl: 'https://poi.staging.curbnturf.com',
  searchApiUrl: 'https://search.staging.curbnturf.com/v1',
  boondockSearchApiUrl: 'https://boondock.staging.curbnturf.com/v1',
  imageUrl: 'https://images.staging.curbnturf.com',
  mapOldAppCode: 'LKVngL6HJzQjfGIcsfjo9w',
  mapOldAppId: '78EtQKL0GXmuIHrx6FQj',
  mapApiKey: 'xOBTyVJNHU0jZNzLJEKd5rCuiP1jwF4ojxbAUnAOXcI',
  mapboxToken: 'pk.eyJ1IjoiamVkc21pdGhjbnQiLCJhIjoiY21rYmVib3dhMDMwYjNmcTUwM3lrcDVzYiJ9.wx9l3NHiUrO1Lp6131-eKw',
  vapidPublic: 'BJ10wNQS3giBrRXBt-E2dECZ6boVgaU8z0tymA4yVvjKjnAx9Tq2wEudYQS8lo1kxfjheCCnE6icuoNOE4ZXYcg',

  // AWS Cognito
  awsRegion: 'us-west-2',
  cognitoUserPoolId: 'us-west-2_eP2KLUT7w',
  cognitoClientId: '5edbh0uqb3f7o9b49gmg2q0sfu',
  cognitoDomain: 'staging-curbnturf.auth.us-west-2.amazoncognito.com',
  cognitoCallback: 'https://admin.staging.curbnturf.com/auth/redirect',

  // Unused in the web app
  cognitoCallbackIOS: 'curbnturf://auth/redirect',
  cognitoLogoutCallbackIOS: 'curbnturf://home/',
  cognitoCallbackApp: 'https://admin.staging.curbnturf.com/auth/redirect',

  convergeGetTokenUrl: '',

  // Ionic Native Only
  offlineDatabaseName: 'curbnturf-offline-data',

  // Google Analytics Code
  gaCode: '',
  ga4Code: '',
};
